<button
  [type]="buttonDetails.type"
  [disabled]="buttonDetails.disabled ||  disabled"
  [ngClass]="{
    'btn-primary': buttonDetails.color == 1,
    'btn-danger': buttonDetails.color == 2,
    'btn-info': buttonDetails.color == 3,
    'btn-success': buttonDetails.color == 4,
    'btn-warning': buttonDetails.color == 5,
    'btn-secondary-overwrite': buttonDetails.color == 6,
    'btn-facebook': buttonDetails.color == 7
  }"
  class="btn form-control text-white {{ buttonDetails?.customStyle }}"
  >
  @if (buttonDetails.hasIcon) {
    <i class="fa fa-{{ buttonDetails.icon }} me-2"></i>
    } {{ buttonDetails.text }}
  </button>
